import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import bannerConfig from '@/config/bannerConfig';

const GlobalBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const bannerHidden = localStorage.getItem(bannerConfig.storageKey);
    if (bannerHidden === 'true') {
      setIsVisible(false);
    }
  }, []);

  const hideBanner = () => {
    setIsVisible(false);
    localStorage.setItem(bannerConfig.storageKey, 'true');
  };

  // Banner nicht anzeigen, wenn er ausgeblendet wurde oder global deaktiviert ist
  if (!isVisible || !bannerConfig.enabled) return null;

  return (
    <div className={`${bannerConfig.backgroundColor} ${bannerConfig.textColor} py-3 relative`}>
      <div className="container">
        <div className="flex items-center justify-center">
          <a 
            href={bannerConfig.linkUrl} 
            className="text-center hover:underline flex-grow"
          >
            <span className="font-bold">{bannerConfig.boldText}</span> {bannerConfig.text}
          </a>
          <Button 
            variant="ghost" 
            size="sm" 
            className={`${bannerConfig.textColor} hover:bg-opacity-20 hover:bg-black p-1 flex-shrink-0`}
            onClick={hideBanner}
            aria-label="Banner ausblenden"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GlobalBanner; 